import { v4 as uuidv4 } from 'uuid';

const snsEnv = function SNSEnvironment(banner, env, platform) {
  const snsBaseHeader = {
    dev: {
      'Ocp-Apim-Subscription-Key': '0cf0338a1e34434bb8b5f3384397ce5f',
    },
    qa: {
      'Ocp-Apim-Subscription-Key': '267402756dc5413ab6ec8bc403100042',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '64e226bfbc1148d3b3f076a33d654595',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': '46d30fd9331a4faa9dd20dce1d4db0f3',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'b47044a7120d4a25aba1738170f979aa',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '379d5b830a494af18fb37cb379afb675',
    },
  };

  const storeLookUpBaseHeader = {
    dev: {
      'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655',
    },
    qa: {
      'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '34a4bf73f22d4782910d7fac910f2a66',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': 'b74a1ecb98394bc4a308747532dc512d',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': '81bbf81be27e46d8a57a4d3f933d6bd0',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': 'b2ea4df305624d96960191e1aaed9b9d',
    },
  };

  const slotsLookupBaseHeader = {
    dev: {
      'Ocp-Apim-Subscription-Key': '3378794a9f5a43b3a360e0c68c9a909a',
    },
    qa: {
      'Ocp-Apim-Subscription-Key': '3378794a9f5a43b3a360e0c68c9a909a',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '74cb5a4f7a554e0db894ed46cbd165fd',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': '19e5b39b4afc425bba33841a60a9dcd5',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'a90946df3e064254ab23b9c70ee99ead',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '6f4598048206487fb8402c5a359fa590',
    },
  };

  const getStatesAndCitiesByZipCode = {
    dev: {
      'Ocp-Apim-Subscription-Key': '3378794a9f5a43b3a360e0c68c9a909a',
    },
    qa: {
      'Ocp-Apim-Subscription-Key': '8ca6295a55f54368844b5982edc1cc01',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '35570fd5f27f4d69948bafbb4dd4f878',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': '6eb4decfcd01473aa5ee0a690cc39006',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'f8bee8d7e7d14a11ac8197d3088cbe3b',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
    },
  };

  const ucaAddressValidationBaseHeader = {
    dev: {
      'Ocp-Apim-Subscription-Key': '3378794a9f5a43b3a360e0c68c9a909a',
    },
    qa: {
      'Ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': 'e5b1bf4a9c124561ba364ac53c2cbc66',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': '2af9cc1fbd3348f1bf4c47ee480542e5',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': '38c2e3420b8b450d9ffd5564ff22c4f0',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '9e38e3f1d32a4279a49a264e0831ea46',
    },
  };

  const biaBaseHeader = {
    qa: {
      'Ocp-Apim-Subscription-Key': '9c09918c6ae44eeb9700d18ed873e519',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '733d5e90e4614b0797b299e54beba169',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': 'e805513f3ff7430e8c27fa147dfef5bd',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'e2caab8471984823a7aedf006da7d894',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
    },
  };

  const autoSuggestHeader = {
    qa: {
      'Ocp-Apim-Subscription-Key': 'a6bbc777a82f45a9b1413af0ce35604f',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '061d4366162045c6879eca9eab9b7e89',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': '49384d1586e9426ab1ab525c95cf18ff',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'f42494b71bf94bd1b87f937a60ee990e',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': 'e914eec9448c4d5eb672debf5011cf8f',
    },
  };

  const searchBaseHeader = {
    qa: {
      'Ocp-Apim-Subscription-Key': 'ae53203f912448a7a13c70272d5c75fb',
    },
    acceptance: {
      'Ocp-Apim-Subscription-Key': '282a6d0c0ff142e485e58154cd248c2d',
    },
    perf: {
      'Ocp-Apim-Subscription-Key': 'a51715bbe5a64a9bb5c008d80d38e362',
    },
    stage: {
      'Ocp-Apim-Subscription-Key': 'b47044a7120d4a25aba1738170f979aa',
    },
    prod: {
      'Ocp-Apim-Subscription-Key': '5e790236c84e46338f4290aa1050cdd4',
    },
  };

  const getKeyAndIframeApi = (environ) => {
    switch (environ) {
      case 'dev':
        return {
          ARO_SUBS_KEY: '6173c51c68254b0dada9ce698e96d2f3',
          REINSTATE_SUBS_KEY: 'ab4d24c982614a3ba20e1ae0593ed3b5',
          GET_TENDER_SUBS_KEY: '45315c1333bc4723a6743c9b6f9cbaef',
          XAPI_SUBS_KEY: '35570fd5f27f4d69948bafbb4dd4f878',
          IFRAME_BASE_API: `https://token-acceptance.albertsons.com`,
        };
      case 'dev2':
        return {
          ARO_SUBS_KEY: '6173c51c68254b0dada9ce698e96d2f3',
          REINSTATE_SUBS_KEY: 'ab4d24c982614a3ba20e1ae0593ed3b5',
          GET_TENDER_SUBS_KEY: 'e5b1bf4a9c124561ba364ac53c2cbc66',
          XAPI_SUBS_KEY: '35570fd5f27f4d69948bafbb4dd4f878',
          IFRAME_BASE_API: `https://token-acceptance.albertsons.com`,
        };
      case 'dev3':
        return {
          ARO_SUBS_KEY: '6173c51c68254b0dada9ce698e96d2f3',
          REINSTATE_SUBS_KEY: 'ab4d24c982614a3ba20e1ae0593ed3b5',
          GET_TENDER_SUBS_KEY: '45315c1333bc4723a6743c9b6f9cbaef',
          XAPI_SUBS_KEY: '35570fd5f27f4d69948bafbb4dd4f878',
          IFRAME_BASE_API: `https://token-acceptance.albertsons.com`,
        };
      case 'qa':
        return {
          ARO_SUBS_KEY: '6173c51c68254b0dada9ce698e96d2f3',
          REINSTATE_SUBS_KEY: '3e4673736413478c8153f99172d30318',
          GET_TENDER_SUBS_KEY: '86a8843aebbe4739af1d84a743752fe1',
          XAPI_SUBS_KEY: '8ca6295a55f54368844b5982edc1cc01',
          IFRAME_BASE_API: `https://token-qa1.albertsons.com`,
        };
      case 'acceptance':
        return {
          ARO_SUBS_KEY: '45000d8081a744fb858f26f463d4f5ae',
          REINSTATE_SUBS_KEY: 'ab4d24c982614a3ba20e1ae0593ed3b5',
          GET_TENDER_SUBS_KEY: '86a8843aebbe4739af1d84a743752fe1',
          XAPI_SUBS_KEY: '35570fd5f27f4d69948bafbb4dd4f878',
          IFRAME_BASE_API: `https://token-acceptance.albertsons.com`,
        };
      case 'perf':
        return {
          ARO_SUBS_KEY: 'c8a4300d1b5048c5946b6b11e5bd9919',
          REINSTATE_SUBS_KEY: 'abb0423b458e4cf6a1f1dad5666a5127',
          GET_TENDER_SUBS_KEY: 'bd25fedc47e045499c7586023803e289',
          XAPI_SUBS_KEY: '6eb4decfcd01473aa5ee0a690cc39006',
          IFRAME_BASE_API: `https://token-perf.albertsons.com`,
        };
      case 'stage':
        return {
          ARO_SUBS_KEY: '0c289898aecf49079e191d369ac648ae',
          REINSTATE_SUBS_KEY: '221f4ec2121a4e79a2676ffb0dae44e0',
          GET_TENDER_SUBS_KEY: '38dc4fcede004d9e8ecdfe49f6c246c6',
          XAPI_SUBS_KEY: 'f8bee8d7e7d14a11ac8197d3088cbe3b',
          IFRAME_BASE_API: `https://token-stage.albertsons.com`,
        };
      case 'alpha':
        return {
          ARO_SUBS_KEY: 'fee1766a73bf47e49fa1e6a02b53308c',
          REINSTATE_SUBS_KEY: 'ab4d24c982614a3ba20e1ae0593ed3b5',
          GET_TENDER_SUBS_KEY: 'd8c6d7783b604f618dd446e7c39c7c08',
          XAPI_SUBS_KEY: '35570fd5f27f4d69948bafbb4dd4f878',
          IFRAME_BASE_API: `https://token.albertsons.com`,
        };
      case 'beta':
        return {
          ARO_SUBS_KEY: 'fee1766a73bf47e49fa1e6a02b53308c',
          REINSTATE_SUBS_KEY: 'c645e9387c654aa8ae253045f648bfac',
          GET_TENDER_SUBS_KEY: '1d8f9e6f8b0d4ce29468d6d82f5847b8',
          XAPI_SUBS_KEY: '7bad9afbb87043b28519c4443106db06',
          IFRAME_BASE_API: `https://token.albertsons.com`,
        };
      case 'prod':
        return {
          ARO_SUBS_KEY: 'fee1766a73bf47e49fa1e6a02b53308c',
          REINSTATE_SUBS_KEY: 'c645e9387c654aa8ae253045f648bfac',
          GET_TENDER_SUBS_KEY: '0fa1435d95894cb08e5461e86cc666fb',
          XAPI_SUBS_KEY: '7bad9afbb87043b28519c4443106db06',
          IFRAME_BASE_API: `https://token.albertsons.com`,
        };
    }
  };
  const getPubAndIntVal = (environ) => {
    switch (environ) {
      case 'dev':
        return {
          pubVal: 'devpub',
          intVal: 'devpub',
          environment: `-dev1`,
        };
      case 'dev2':
      case 'dev3':
        return {
          pubVal: 'devpub',
          intVal: 'devpub',
          environment: `-${environ}`,
        };
      case 'qa':
        return {
          pubVal: 'qapub',
          intVal: 'qaint',
          environment: '-qa1',
        };
      case 'acceptance':
        return {
          pubVal: 'acceptancepub',
          intVal: 'qaint',
          environment: '-qa2',
        };
      case 'perf':
        return {
          pubVal: 'perfpub',
          intVal: 'perfint',
          environment: '-qa3',
        };
      case 'stage':
        return {
          pubVal: 'stagepub',
          intVal: 'stageint',
          environment: '-stage',
        };
      case 'alpha':
      case 'beta':
        return {
          pubVal: 'pub',
          intVal: 'int',
          environment: `-${environ}`,
        };
      case 'prod':
        return {
          pubVal: 'pub',
          intVal: 'int',
          environment: '',
        };
    }
  };
  const getExternalPubAndIntVal = (environ) => {
    switch (environ) {
      case 'dev':
        return {
          pubValue: 'devpub',
          environmentValue: `-dev1`,
        };
      case 'dev2':
      case 'dev3':
        return {
          pubValue: 'devpub',
          environmentValue: `-${environ}`,
        };
      case 'qa':
        return {
          pubValue: 'qapub',
          environmentValue: '-qa1',
        };
      case 'acceptance':
        return {
          pubValue: 'acceptancepub',
          environmentValue: '-qa2',
        };
      case 'perf':
        return {
          pubValue: 'perfpub',
          environmentValue: '-qa3',
        };
      case 'stage':
        return {
          pubValue: 'stgpub',
          environmentValue: '-stage',
        };
      case 'alpha':
      case 'beta':
        return {
          pubValue: 'pub',
          environmentValue: `-${environ}`,
        };
      case 'prod':
        return {
          pubValue: 'pub',
          environmentValue: '',
        };
    }
  };
  const date = new Date().toString();
  const subsKeysAndApi = getKeyAndIframeApi(env);
  // Note: environment variable is only for local
  const { pubVal, intVal, environment } = getPubAndIntVal(env);
  const { pubValue, environmentValue } = getExternalPubAndIntVal(env);
  if (window.location.href.indexOf('local') > 0) {
    return {
      SSO_URL: `https://www${environment}.${banner}.com/bin/safeway/sso`,
      SIGN_IN_URL: `https://www${environment}.${banner}.com/account/sign-in.html`,
      RE_SIGN_IN_URL: `https://www${environment}.${banner}.com/account/re-sign-in.html`,
      AUTH_API: `https://www${environment}.${banner}.com/bin/safeway/unified/userinfo?banner=${banner}`,
      LEFT_NAV_API: `https://www${environment}.${banner}.com/bin/safeway/ucanavigation?banner=${banner}`,
      LEFT_NAV_API_V2: `https://www${environment}.${banner}.com/content/experience-fragments/www/${banner}/en/generic_content/uca-navigation-v2/uca-navigation-v2/jcr:content/root/responsivegrid/uca_navigation-v2.model.json`,
      UCA_BASE_API: `https://www${environment}.${banner}.com/abs/${pubVal}/cnc/ucaservice/api/uca/customers/`,
      ZIPCODE_TO_CITY_API: `https://www${environment}.${banner}.com/abs/${pubValue}/xapi/storeresolver/zipcodetocity?zipcode={{zipcode}}`,
      STORES_BY_ADDRESS: `https://www${environment}.${banner}.com/abs/${pubValue}/xapi/storeresolver/v2/storesByAddress`,
      SNS_UPCOMING_ORDER_API: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_CANCELED_ITEMS_API: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_ALL_ACTIVE_ITEMS_API: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_FUTURE_ORDERS_API: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_UPDATE_ITEM_INFO: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_SKIP_ITEM_INFO: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_SKIP_ORDER: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_ALL_ACTIVE_ADDRESSES: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_ALL_FREQUENCIES: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/allFrequencies`,
      SNS_REACTIVATE_SUBSCRIPTION: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_CANCEL_SUBSCRIPTION: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_EDIT_QUANTITY: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_ALL_PREFERENCES: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/`,
      SNS_UPDATE_CARD_STATUS: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/updatePaymentStatus`,
      SNS_GET_SUBSTITUTIONS: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/{{BPIN}}/getSubstitutions`,
      STORE_LOCATOR_API: `https://www${environment}.${banner}.com/api/services/locator/store/pickup`,
      SNS_SLOTS_INFO: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/getAllSlots`,
      GET_ALL_AVAILABLE_SLOTS_INFO: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/getAvailableSlots`,
      SNS_SLOTS_UPDATE: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
      SNS_NEXT_ORDER_SLOTS_UPDATE: `https://www-${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/updateNextOrderSlot`,
      SNS_VALIDATE_ADDRESS: `https://www${environment}.${banner}.com/abs/${pubValue}/cnc/ucaservice/api/uca/customers/{{UUID}}/addresses`,
      SNS_ZIPCODE_LOOKUP: `https://www${environment}.${banner}.com/api/services/locator/store/delivery?zipcode={{zipcode}}`,
      SNS_STORE_DETAILS: `https://www${environment}.${banner}.com/api/services/locator/entity/store/{{storeId}}`,
      SNS_SAVE_ADDRESS: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
      SNS_UPDATE_DRIVER_TIP: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch//api/sns/{{UUID}}/updateDriverTip`,
      UPDATE_DELIVERY_INSTRUCTIONS: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
      SNS_AUTOSUGGEST_KEYWORDS: `https://www${environment}.${banner}.com/abs/${pubVal}/xapi/search/autosuggest`,
      SNS_PRODUCT_SEARCH: `https://www${environment}.${banner}.com/abs/${pubVal}/xapi/pgmsearch/v1/search/products`,
      SNS_BUYITAGAIN: `https://www${environment}.${banner}.com/abs/${pubVal}/xapi/p13n/products`,
      SNS_ADD_SUBSCRIPTION_ONETIME: `https://www${environment}.${banner}.com/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/addSubscriptionOneTime?banner=${banner}`,
      API_HEADERS_GET_V1: {
        ...snsBaseHeader[env],
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
      },
      API_HEADERS_GET_V4: {
        ...ucaAddressValidationBaseHeader[env],
        Accept: 'application/vnd.safeway.v4+json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
      },
      STORE_LOOKUP_API_HEADERS_GET_V1: {
        ...storeLookUpBaseHeader[env],
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
      },
      SLOTS_LOOKUP_API_HEADERS_GET_V1: {
        ...slotsLookupBaseHeader[env],
        Accept: 'application/json, text/plain, */*',
        clientId: 'AR',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      },
      ZIPCODE_LOOKUP_API_HEADERS_GET_V1: {
        ...getStatesAndCitiesByZipCode[env],
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
      },
      API_HEADERS_GET_V2: {
        ...snsBaseHeader[env],
        Accept: 'application/vnd.safeway.v2+json',
        'x-swy_banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-banner': banner,
      },
      API_HEADERS_GET_V2_CACHE_CONTROL: {
        ...snsBaseHeader[env],
        Accept: 'application/vnd.safeway.v2+json',
        'x-swy_banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
        'Cache-Control': 'no-cache',
      },
      API_HEADERS_GET_V3: {
        ...snsBaseHeader[env],
        Accept: 'application/vnd.safeway.v3+json',
        'content-type': 'application/vnd.safeway.v4+json',
        'x-swy_banner': banner,
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-date': date,
        'x-swy-banner': banner,
      },
      API_HEADERS_PATCH_V1: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v1+json',
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy-banner': banner,
        'x-swy_banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      },
      API_HEADERS_PATCH_V2: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v2.merge-patch+json',
        Accept: 'application/vnd.safeway.v2+json',
        'x-swy_banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      },
      API_HEADERS_PATCH_V3: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v3.merge-patch+json',
        Accept: 'application/vnd.safeway.v3+json',
        'x-swy_banner': banner,
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-date': date,
        'x-swy-banner': banner,
      },
      API_HEADERS_POST_V1: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v1+json',
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      },
      API_HEADERS_POST_V1_CACHE_CONTROL: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v1+json',
        Accept: 'application/vnd.safeway.v1+json',
        'x-swy_banner': banner,
        'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
        'Cache-Control': 'no-cache',
      },
      API_HEADERS_POST_V2: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v2+json',
        Accept: 'application/vnd.safeway.v2+json',
        'x-swy-banner': banner,
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      },
      API_HEADERS_POST_V3: {
        ...snsBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v3+json',
        Accept: 'application/vnd.safeway.v3+json',
        'x-swy-banner': banner,
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-correlation-id': uuidv4(),
        'x-swy-date': date,
      },
      GEO_STORES_BY_ADDRESS_API_HEADERS_POST_V2: {
        ...getStatesAndCitiesByZipCode[env],
        Accept: 'application/json',
        'x-swy_banner': banner,
        'x-swy-banner': banner,
        'x-swy-request-id': uuidv4(),
        'Cache-Control': 'no-cache',
      },
      UCA_VALIDATION_API_HEADERS_POST_V3: {
        ...ucaAddressValidationBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v3+json',
        Accept: 'application/vnd.safeway.v3+json',
        'x-swy-banner': banner,
        'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
        'x-swy-correlation-id': uuidv4(),
        'x-swy-date': date,
      },
      BIA_API_HEADERS_POST: {
        ...biaBaseHeader[env],
        'Content-Type': 'application/vnd.safeway.v2+json',
        Accept: 'application/json',
        'x-swy-banner': banner,
        platform: platform === 'web' ? 'web' : 'mobile',
      },
      AUTO_SUGGEST_API_HEADERS_GET: {
        ...autoSuggestHeader[env],
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      SEARCH_API_HEADERS_GET: {
        ...searchBaseHeader[env],
        'Content-Type': 'application/json',
        'x-swy-banner': banner,
        Accept: 'application/json',
      },
      CHECK_USER_ACTIVE_SESSION: false,
      CHECK_STEP_UP_AUTHENTICATION: true,
      ...subsKeysAndApi,
      environmentValue,
    };
  }
  const envObj = {
    SSO_URL: `/bin/safeway/sso`,
    SIGN_IN_URL: `/account/sign-in.html`,
    RE_SIGN_IN_URL: `/account/re-sign-in.html`,
    AUTH_API: `/bin/safeway/unified/userinfo?banner=${banner}`,
    LEFT_NAV_API: `/bin/safeway/ucanavigation?banner=${banner}`,
    LEFT_NAV_API_V2: `/content/experience-fragments/www/${banner}/en/generic_content/uca-navigation-v2/uca-navigation-v2/jcr:content/root/responsivegrid/uca_navigation-v2.model.json`,
    UCA_BASE_API: `/abs/${pubVal}/cnc/ucaservice/api/uca/customers/`,
    ZIPCODE_TO_CITY_API: `/abs/${pubValue}/xapi/storeresolver/zipcodetocity?zipcode={{zipcode}}`,
    STORES_BY_ADDRESS: `/abs/${pubValue}/xapi/storeresolver/v2/storesByAddress`,
    SNS_UPCOMING_ORDER_API: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_CANCELED_ITEMS_API: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_FUTURE_ORDERS_API: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_ALL_ACTIVE_ITEMS_API: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_UPDATE_ITEM_INFO: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_SKIP_ITEM_INFO: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_SKIP_ORDER: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_ALL_ACTIVE_ADDRESSES: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_ALL_FREQUENCIES: `/abs/${pubVal}/osar/snsorderorch/api/sns/allFrequencies`,
    SNS_REACTIVATE_SUBSCRIPTION: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_CANCEL_SUBSCRIPTION: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_EDIT_QUANTITY: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_ALL_PREFERENCES: `/abs/${pubVal}/osar/snsorderorch/api/sns/`,
    SNS_UPDATE_CARD_STATUS: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/updatePaymentStatus`,
    SNS_GET_SUBSTITUTIONS: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/{{BPIN}}/getSubstitutions`,
    STORE_LOCATOR_API: `/api/services/locator/store/pickup`,
    SNS_SLOTS_INFO: `/abs/${pubVal}/osar/snsorderorch/api/sns/getAllSlots`,
    GET_ALL_AVAILABLE_SLOTS_INFO: `/abs/${pubVal}/osar/snsorderorch/api/sns/getAvailableSlots`,
    SNS_SLOTS_UPDATE: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
    SNS_NEXT_ORDER_SLOTS_UPDATE: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/updateNextOrderSlot`,
    SNS_VALIDATE_ADDRESS: `/abs/${pubValue}/cnc/ucaservice/api/uca/customers/{{UUID}}/addresses`,
    SNS_ZIPCODE_LOOKUP: `/api/services/locator/store/delivery?zipcode={{zipcode}}`,
    SNS_STORE_DETAILS: `/api/services/locator/entity/store/{{storeId}}`,
    SNS_SAVE_ADDRESS: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
    SNS_UPDATE_DRIVER_TIP: `/abs/${pubVal}/osar/snsorderorch//api/sns/{{UUID}}/updateDriverTip`,
    UPDATE_DELIVERY_INSTRUCTIONS: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/preferences`,
    SNS_AUTOSUGGEST_KEYWORDS: `/abs/${pubVal}/xapi/search/autosuggest`,
    SNS_PRODUCT_SEARCH: `/abs/${pubVal}/xapi/pgmsearch/v1/search/products`,
    SNS_BUYITAGAIN: `/abs/${pubVal}/xapi/p13n/products`,
    SNS_ADD_SUBSCRIPTION_ONETIME: `/abs/${pubVal}/osar/snsorderorch/api/sns/{{UUID}}/addSubscriptionOneTime?banner=${banner}`,
    API_HEADERS_GET_V1: {
      ...snsBaseHeader[env],
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-request-id': uuidv4(),
    },
    API_HEADERS_GET_V4: {
      ...ucaAddressValidationBaseHeader[env],
      Accept: 'application/vnd.safeway.v4+json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-request-id': uuidv4(),
    },
    STORE_LOOKUP_API_HEADERS_GET_V1: {
      ...storeLookUpBaseHeader[env],
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-request-id': uuidv4(),
      'Cache-Control': 'no-cache',
    },
    SLOTS_LOOKUP_API_HEADERS_GET_V1: {
      ...slotsLookupBaseHeader[env],
      Accept: 'application/json, text/plain, */*',
      clientId: 'AR',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-request-id': uuidv4(),
      'Cache-Control': 'no-cache',
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
    },
    ZIPCODE_LOOKUP_API_HEADERS_GET_V1: {
      ...getStatesAndCitiesByZipCode[env],
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-request-id': uuidv4(),
      'Cache-Control': 'no-cache',
    },
    API_HEADERS_GET_V2: {
      ...snsBaseHeader[env],
      Accept: 'application/vnd.safeway.v2+json',
      'x-swy_banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-banner': banner,
    },
    API_HEADERS_GET_V3: {
      ...snsBaseHeader[env],
      Accept: 'application/vnd.safeway.v3+json',
      'content-type': 'application/vnd.safeway.v4+json',
      'x-swy_banner': banner,
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-date': date,
      'x-swy-banner': banner,
    },
    API_HEADERS_PATCH_V1: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v1+json',
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy-banner': banner,
      'x-swy_banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
    },
    API_HEADERS_PATCH_V2: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v2.merge-patch+json',
      Accept: 'application/vnd.safeway.v2+json',
      'x-swy_banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
    },
    API_HEADERS_PATCH_V3: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v3.merge-patch+json',
      Accept: 'application/vnd.safeway.v3+json',
      'x-swy_banner': banner,
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-date': date,
      'x-swy-banner': banner,
    },
    API_HEADERS_POST_V1: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v1+json',
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
    },
    API_HEADERS_POST_V1_CACHE_CONTROL: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v1+json',
      Accept: 'application/vnd.safeway.v1+json',
      'x-swy_banner': banner,
      'x-swy-client-id': platform === 'web' ? 'web-portal' : 'mobile',
      'Cache-Control': 'no-cache',
    },
    API_HEADERS_POST_V2: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v2+json',
      Accept: 'application/vnd.safeway.v2+json',
      'x-swy-banner': banner,
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
    },
    API_HEADERS_POST_V3: {
      ...snsBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v3+json',
      Accept: 'application/vnd.safeway.v3+json',
      'x-swy-banner': banner,
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-correlation-id': uuidv4(),
      'x-swy-date': date,
    },
    GEO_STORES_BY_ADDRESS_API_HEADERS_POST_V2: {
      ...getStatesAndCitiesByZipCode[env],
      Accept: 'application/json',
      'x-swy_banner': banner,
      'x-swy-banner': banner,
      'x-swy-request-id': uuidv4(),
      'Cache-Control': 'no-cache',
    },
    UCA_VALIDATION_API_HEADERS_POST_V3: {
      ...ucaAddressValidationBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v3+json',
      Accept: 'application/vnd.safeway.v3+json',
      'x-swy-banner': banner,
      'x-swy-client-name': platform === 'web' ? 'web-portal' : 'mobile',
      'x-swy-correlation-id': uuidv4(),
      'x-swy-date': date,
    },
    BIA_API_HEADERS_POST: {
      ...biaBaseHeader[env],
      'Content-Type': 'application/vnd.safeway.v2+json',
      Accept: 'application/json',
      'x-swy-banner': banner,
      platform: platform === 'web' ? 'web' : 'mobile',
    },
    AUTO_SUGGEST_API_HEADERS_GET: {
      ...autoSuggestHeader[env],
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    SEARCH_API_HEADERS_GET: {
      ...searchBaseHeader[env],
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'x-swy-banner': banner,
    },
    CHECK_USER_ACTIVE_SESSION: true,
    CHECK_STEP_UP_AUTHENTICATION: true,
    ...subsKeysAndApi,
    environmentValue,
  };
  return envObj;
};

export default snsEnv;
